import React from 'react'
import { TidewaysContext } from '../../app/context'
import Navigator from '../../app/navigator'
import { GraphEntity } from '../../domain/GraphEntity'
import { OperationsGraphEntity } from '../../redux/operations/OperationsState'
import Snapshot from '../snapshot/snapshotModel'
import Chart from './downstream.d3'
import { observeElement, unobserveElement } from '../../helper/resizeObserver'
import { convertDate } from '../../helper/convertDate'

interface Props {
    data: GraphEntity | OperationsGraphEntity
    navigator: Navigator
    parameters: { [key: string]: string }
    tidewaysContext: TidewaysContext
    onTimestampSelected: (
        timestamp: string,
        timestampNext: string,
        mouse: {
            x: number
            y: number
            width: number
        },
    ) => void
    onChartCreated: (chart: typeof Chart) => void
    dataFixedTimezone?: string
    idSuffix?: string
    yAxisMax?: number | null
}
class Downstream extends React.PureComponent<Props> {
    public SVGType: SVGSVGElement | string | null = null
    public nodes = { downstreamSvg: this.SVGType }
    public chart
    public resizeObserver

    public componentDidMount() {
        if (!this.chart) {
            this.createChart()
        }

        setTimeout(() => {
            this.forceUpdate()
        }, 0)

        jQuery(this.chart).on('rangeSelected', (e, dataSet, nextDataSet) => {
            this.props.navigator.push(Snapshot.fromDataSets(dataSet, nextDataSet).toParameters(), 'XhprofProfilerBundle.Snapshot.show')
        })

        jQuery(this.chart).on('rangeDelesect', e => {
            this.props.navigator.push({ date: null, end: null }, 'XhprofOrganizationBundle.Application.show')
        })
    }

    public componentDidUpdate(prevProps) {
        if (!this.chart) {
            this.createChart()
        }
        if (!this.resizeObserver && this.chart) {
            this.setResizeObserver()
        }

        if (this.props.data) {
            this.updateChart()
        }
    }

    public createChart() {
        this.chart = new Chart()

        const chartElement = this.getChartElement()
        const parentNode = jQuery(chartElement as string).parent()

        parentNode.height(145)
        this.chart.create(chartElement, parentNode.width(), 140, {}, this.props.onTimestampSelected, this.props.idSuffix)

        this.props.onChartCreated(this.chart)

        if (this.props.data) {
            this.updateChart()
        }
    }

    public componentWillUnmount() {
        this.destroyChart()

        const chartElement = this.getChartElement()
        if (chartElement) {
            const parentNode = jQuery(chartElement as string).parent()
            if (parentNode[0]) {
                unobserveElement(parentNode[0])
            }
        }
    }

    public getChartElement = () => this.nodes.downstreamSvg

    public updateChart = () => {
        this.chart.update(
            Object.entries(this.props.data.report.averageResponseTimes).map(([key, value]) => ({
                date: convertDate(key, this.props.dataFixedTimezone),
                dateUtc: key,
                averageResponse: value,
                downstream: this.props.data.report.downstream[key],
                requests: this.props.data.report.requests[key],
            })),
            this.props.parameters.end ? Snapshot.fromParameters(this.props.parameters).getRangeMarker() : [],
            this.props.yAxisMax,
        )
    }

    private rebuildChart = () => {
        this.destroyChart()
        this.createChart()
        if (this.chart) this.updateChart()
    }

    private destroyChart = () => {
        this.chart?.destroy() // remove svg-elements from dom
        this.chart = null // remove reference to the object
    }

    private setResizeObserver = () => {
        const chartElement = this.getChartElement()

        const parentNode = jQuery(chartElement as string).parent()
        this.resizeObserver = observeElement(parentNode[0], this.rebuildChart)
    }

    public render() {
        return (
            <div className="row">
                <div className="col-lg-12 text-center">
                    <div className="chart downstream">
                        <svg
                            ref={element => {
                                this.nodes.downstreamSvg = element
                            }}
                        />
                    </div>
                </div>
            </div>
        )
    }
}

export default Downstream
